require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-current-promotions-heloc-special.json") })
        }
      }, "path---es-articles-current-promotions-heloc-special");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-current-promotions-heloc-special!./.cache/json/es-articles-current-promotions-heloc-special.json
// module id = 2054
// module chunks = 231608221292675